import React from "react";

export default function PermissionDenied() {
  return (
    <div style={{ display: "flex",flexDirection:"column" ,padding: 60,justifyContent:"center" ,alignItems:"center",textAlign: "center",background:'#fff', width:"100vh",height:'100vw' }}>
      <h1>Permission Denied</h1>
      <p>You do not have access to view this page.</p>
    </div>
  );
}




